import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmModal } from 'components/_basic/ConfirmModal/ConfirmModal';

import { IAICancelConfirmModalProps } from './types';

import styles from './AICancelConfirmModal.module.scss';

export const AICancelConfirmModal: React.FC<IAICancelConfirmModalProps> = ({ onAbort, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <ConfirmModal
      title={t('ai.aiCancelConfirmModal.stopGeneration')}
      body={t('ai.aiCancelConfirmModal.areYouSure')}
      confirmButtonColor="error"
      confirmText={t('ai.aiCancelConfirmModal.stopGeneration')}
      className={styles.modal}
      fullWidthButtons
      maxWidth={false}
      onAbort={onAbort}
      onConfirm={onConfirm}
    />
  );
};
